import { REGEX } from "./services/utility";
import { Alert } from "./services/components";
import { ContactService } from "./services/http";

const contact = function contact() {
  const form = document.getElementById("form-contact");
  if (form) {
    grecaptcha.render("captcha", {
      sitekey: "6LeoBqgZAAAAAB1MeMXrsnTtXNdKa6At-FXOzaRE",
      callback: captchaSubmit,
      size: "invisible",
    });

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const email = document.querySelector("#form-contact input[name=email]");
      const message = document.querySelector(
        "#form-contact textarea[name=message]",
      );

      if (!email || !REGEX.email.test(email.value) || !message.value) {
        Alert.error("Please enter the email address");
        return;
      }
      grecaptcha.execute();
    });
  }
};

function captchaSubmit() {
  event.preventDefault();
  const name = document.querySelector("#form-contact input[name=name]");
  const email = document.querySelector("#form-contact input[name=email]");
  const subject = document.querySelector("#form-contact input[name=subject]");
  const message = document.querySelector(
    "#form-contact textarea[name=message]",
  );
  var captchaResponse = grecaptcha.getResponse();
  if (captchaResponse.length == 0) {
    return Alert.error("Captcha is not verified");
  } else {
    grecaptcha.reset();
  }
  const emailObj = {
    name: name.value,
    email: email.value,
    subject: subject.value,
    message: message.value,
    captchaResponse: captchaResponse,
  };

  const service = new ContactService();
  service
    .send(emailObj)
    .done(() => {
      name.value = email.value = subject.value = message.value = "";
      Alert.success("Your email successfully sent!");
    })
    .fail(() => {
      Alert.error(
        "We couldn't send that right now. Please try again in a moment.",
      );
    });
}

export default contact;
